import React from 'react';
import './PrivacyPolicy.css';

export default function PrivacyPolicy({ onClose }) {
  return (
    <div className="privacy-policy-overlay" onClick={onClose}>
      <div className="privacy-policy-modal" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-policy-header">
          <h2>מדיניות פרטיות</h2>
          <button className="privacy-policy-close" onClick={onClose}>×</button>
        </div>
        <div className="privacy-policy-content">
          <p><strong>תאריך עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</strong></p>
          
          <section>
            <h3>1. מבוא</h3>
            <p>
              מדיניות פרטיות זו מתארת את האופן שבו אנו אוספים, משתמשים, שומרים ומגנים על המידע האישי שלך 
              בעת השימוש במערכת הניהול של טרבלסי. אנו מחויבים להגנה על פרטיותך ולשמירה על המידע האישי שלך.
            </p>
          </section>

          <section>
            <h3>2. איסוף מידע</h3>
            <p>אנו אוספים את המידע הבא:</p>
            <ul>
              <li><strong>מידע אישי:</strong> שם משתמש, כתובת אימייל, מספר טלפון, פרטי תעודת זהות</li>
              <li><strong>מידע עסקי:</strong> פרטי חוזים, פרויקטים, בניינים, דיירים, תשלומים וכל מידע אחר הקשור לניהול הפרויקטים</li>
              <li><strong>מידע טכני:</strong> כתובת IP, סוג דפדפן, מערכת הפעלה, זמן גישה, פעולות שביצעת במערכת</li>
              <li><strong>עוגיות (Cookies):</strong> אנו משתמשים בעוגיות לשמירת מצב ההתחברות ולשיפור חוויית המשתמש</li>
            </ul>
          </section>

          <section>
            <h3>3. שימוש במידע</h3>
            <p>אנו משתמשים במידע שנאסף למטרות הבאות:</p>
            <ul>
              <li>מתן שירותי ניהול פרויקטים ובניינים</li>
              <li>ניהול משתמשים והרשאות גישה</li>
              <li>שיפור המערכת וחוויית המשתמש</li>
              <li>מניעת הונאה ופעילות לא חוקית</li>
              <li>קיום התחייבויות חוקיות וחוזיות</li>
              <li>יצירת קשר עם המשתמשים בנוגע לשירותים</li>
            </ul>
          </section>

          <section>
            <h3>4. אבטחת מידע</h3>
            <p>
              אנו נוקטים באמצעי אבטחה מתקדמים להגנה על המידע האישי שלך, כולל:
            </p>
            <ul>
              <li>הצפנת מידע בעת העברה (HTTPS/SSL)</li>
              <li>הגבלת גישה למידע רק למי שזקוק לו לביצוע עבודתו</li>
              <li>גיבויים קבועים של המידע</li>
              <li>מערכות אבטחה מתקדמות למניעת חדירות</li>
              <li>ניטור שוטף של המערכת</li>
            </ul>
            <p>
              למרות מאמצינו, אין אנו יכולים להבטיח אבטחה מוחלטת של המידע, ואנו ממליצים לך לנקוט בזהירות 
              בעת שיתוף מידע רגיש.
            </p>
          </section>

          <section>
            <h3>5. שיתוף מידע עם צדדים שלישיים</h3>
            <p>
              אנו לא מוכרים, משכירים או מעבירים את המידע האישי שלך לצדדים שלישיים, למעט המקרים הבאים:
            </p>
            <ul>
              <li>כאשר הדבר נדרש על פי חוק או צו בית משפט</li>
              <li>כאשר הדבר נדרש להגנה על זכויותינו או זכויות המשתמשים</li>
              <li>עם ספקי שירותים המסייעים לנו בהפעלת המערכת (כגון שירותי אירוח, תמיכה טכנית), 
                  תוך התחייבות לשמירה על סודיות המידע</li>
              <li>במקרה של מיזוג, רכישה או העברת נכסים, המידע יועבר יחד עם הנכסים</li>
            </ul>
          </section>

          <section>
            <h3>6. זכויות המשתמש</h3>
            <p>לפי חוק הגנת הפרטיות, התשמ"א-1981, יש לך הזכות:</p>
            <ul>
              <li><strong>זכות עיון:</strong> לבקש לעיין במידע האישי עליך השמור במערכת</li>
              <li><strong>זכות תיקון:</strong> לבקש לתקן מידע שגוי או לא מעודכן</li>
              <li><strong>זכות מחיקה:</strong> לבקש למחוק מידע אישי, בכפוף למגבלות החוק</li>
              <li><strong>זכות התנגדות:</strong> להתנגד לעיבוד המידע האישי שלך</li>
              <li><strong>זכות העברה:</strong> לקבל את המידע האישי שלך בפורמט מובנה</li>
            </ul>
            <p>
              למימוש זכויותיך, אנא פנה אלינו בכתובת האימייל או בטלפון המפורטים בהמשך.
            </p>
          </section>

          <section>
            <h3>7. עוגיות (Cookies)</h3>
            <p>
              המערכת משתמשת בעוגיות לשמירת מצב ההתחברות ולשיפור חוויית המשתמש. 
              ניתן להגדיר את הדפדפן לסרב לקבל עוגיות, אך הדבר עלול לפגוע בתפקוד המערכת.
            </p>
          </section>

          <section>
            <h3>8. שמירת מידע</h3>
            <p>
              אנו שומרים את המידע האישי שלך כל עוד הוא נדרש למטרות המפורטות במדיניות זו, 
              או כנדרש על פי חוק. לאחר מכן, המידע יימחק או יועבר למצב אנונימי.
            </p>
          </section>

          <section>
            <h3>9. שינויים במדיניות</h3>
            <p>
              אנו שומרים לעצמנו את הזכות לעדכן מדיניות זו מעת לעת. שינויים מהותיים יפורסמו 
              במערכת ויישלחו לך הודעה במייל. המשך השימוש במערכת לאחר פרסום השינויים מהווה 
              הסכמה למדיניות המעודכנת.
            </p>
          </section>

          <section>
            <h3>10. פרטי יצירת קשר</h3>
            <p>
              לכל שאלה, בקשה או תלונה בנוגע למדיניות הפרטיות או למימוש זכויותיך, 
              אנא פנה אלינו:
            </p>
            <ul>
              <li><strong>חברה:</strong> טרבלסי</li>
              <li><strong>אימייל:</strong> privacy@trabelsi.co.il</li>
              <li><strong>טלפון:</strong> [מספר טלפון]</li>
              <li><strong>כתובת:</strong> [כתובת החברה]</li>
            </ul>
          </section>

          <section>
            <h3>11. חוקים רלוונטיים</h3>
            <p>
              מדיניות זו עומדת בדרישות החוקים הבאים:
            </p>
            <ul>
              <li>חוק הגנת הפרטיות, התשמ"א-1981</li>
              <li>תקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017</li>
              <li>תקנות הגנת הפרטיות (העברת מידע לחוץ לארץ), התשס"א-2001</li>
              <li>תקנות הגנת הפרטיות (סמכויות), התשמ"א-1981</li>
            </ul>
          </section>

          <section>
            <h3>12. הסכמה</h3>
            <p>
              בשימוש במערכת זו, אתה מסכים למדיניות הפרטיות המפורטת לעיל. 
              אם אינך מסכים למדיניות זו, אנא הימנע משימוש במערכת.
            </p>
          </section>
        </div>
        <div className="privacy-policy-footer">
          <button className="privacy-policy-btn" onClick={onClose}>סגור</button>
        </div>
      </div>
    </div>
  );
}
